/* eslint-disable fp/no-mutation */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export const TRACKING_PARAMS = {
  IM_REF: 'im_ref',
  IRCLICKID: 'irclickid',
} as const;

export type TrackingReduxState = {
  imRef?: string;
  imRefTimestamp?: number;
  irClickId?: string;
  irClickIdTimestamp?: number;
};

const initialState: TrackingReduxState = {};

const trackingSlice = createSlice({
  initialState,
  name: 'tracking',
  reducers: {
    clearExpiredImRef: (state) => {
      state.imRef = undefined;
      state.imRefTimestamp = undefined;
    },
    clearExpiredIrClickId: (state) => {
      state.irClickId = undefined;
      state.irClickIdTimestamp = undefined;
    },
    clearTracking: (state) => {
      state.irClickId = undefined;
      state.irClickIdTimestamp = undefined;
      state.imRef = undefined;
      state.imRefTimestamp = undefined;
    },
    setImRef: (state, { payload }: PayloadAction<string>) => {
      state.imRef = payload;
      state.imRefTimestamp = Date.now();
    },
    setIrClickId: (state, { payload }: PayloadAction<string>) => {
      state.irClickId = payload;
      state.irClickIdTimestamp = Date.now();
    },
  },
});

export const { reducer: trackingReducer } = trackingSlice;
export const { clearExpiredImRef, clearExpiredIrClickId, clearTracking, setImRef, setIrClickId } =
  trackingSlice.actions;
